import { defineComponent as L, ref as p, watchEffect as N, nextTick as S, computed as y, openBlock as c, createElementBlock as C, createVNode as f, unref as i, withCtx as b, createElementVNode as x, normalizeClass as n, normalizeStyle as V, createBlock as k, Fragment as K, renderList as Q, toDisplayString as R, createCommentVNode as T } from "vue";
import $ from "./index60.js";
import { Combobox as q, ComboboxInput as P, ComboboxButton as U, ComboboxOptions as j, ComboboxOption as A } from "./index269.js";
const G = { class: "base-combobox-wrapper relative w-full" }, H = { class: "relative w-full" }, J = { class: "block truncate" }, Y = /* @__PURE__ */ L({
  __name: "BaseStringComboBox",
  props: {
    modelValue: { default: void 0 },
    options: { default: () => [] },
    size: { default: "sm" },
    disabled: { type: Boolean, default: !1 },
    allowFreeInput: { type: Boolean, default: !1 },
    placeholder: { default: "선택하세요" },
    variant: { default: "default" }
  },
  emits: ["update:modelValue", "blur", "open-change"],
  setup(s, { emit: _ }) {
    const e = s, a = _, o = p(""), m = p(""), d = p(!1), v = p(null), B = () => {
      d.value = !1, a("open-change", !1), E();
    };
    N(async () => {
      const t = v.value;
      if (await S(), t) {
        const l = t.offsetParent !== null;
        l !== d.value && (d.value = l, a("open-change", l));
      } else d.value && (d.value = !1, a("open-change", !1));
    });
    const h = y({
      get() {
        if (e.modelValue == null) return null;
        if (e.modelValue === "") {
          const l = e.options?.find((u) => u.value === "");
          return l || null;
        }
        const t = e.options?.find((l) => l.value === e.modelValue);
        return t || {
          value: e.modelValue,
          label: e.modelValue
        };
      },
      set(t) {
        t ? (a("update:modelValue", t.value), o.value = "") : (a("update:modelValue", void 0), o.value = "");
      }
    }), g = y(() => {
      if (!e.options?.length || !o.value) return e.options || [];
      const t = o.value.toLowerCase();
      return e.options.filter(
        (l) => l.label.toLowerCase().includes(t) || l.value.toLowerCase().includes(t)
      );
    }), z = (t) => {
      const l = t.target.value;
      if (o.value = l, m.value = l, !!e.allowFreeInput) {
        if (l === "") {
          a("update:modelValue", void 0), o.value = "";
          return;
        }
        a("update:modelValue", l);
      }
    }, O = (t) => {
      t.key === "Enter" && e.allowFreeInput && (t.preventDefault(), setTimeout(() => {
        t.target.blur();
      }, 0));
    }, w = () => {
      a("blur", o.value || m.value);
    }, E = () => {
      w();
    }, D = (t) => t?.label || "";
    return (t, l) => (c(), C("div", G, [
      f(i(q), {
        modelValue: h.value,
        "onUpdate:modelValue": l[0] || (l[0] = (u) => h.value = u),
        disabled: s.disabled,
        nullable: "",
        onClose: B
      }, {
        default: b(({ open: u }) => [
          x("div", H, [
            x("div", {
              class: n([
                "relative flex w-full overflow-hidden rounded-md border border-solid bg-[var(--input-color-surface)] transition-all duration-150",
                e.disabled ? "border-input-border-disabled text-input-text-disable cursor-not-allowed !bg-[var(--base-colors-neutral-neutral200)]" : e.variant === "compact" ? "border-input-border-static hover:border-input-border-static focus-within:border-input-border-static focus-within:shadow-none" : "border-input-border-static focus-within:border-input-border-focus hover:border-input-border-focus focus-within:shadow-[0_0_0_1px_var(--input-color-border-focus)]",
                e.variant === "compact" ? "h-[24px] rounded-[4px] px-[10px] text-[12px] leading-[14px] focus-within:shadow-none" : e.size === "sm" ? "h-[36px] px-[15px] text-[14px] leading-[16px]" : "h-[42px] px-[15px] text-[16px] leading-[20px]"
              ])
            }, [
              f(i(P), {
                "display-value": D,
                autocomplete: "off",
                class: n([
                  "w-full border-0 bg-transparent tracking-[-0.35px] outline-none",
                  e.variant === "compact" ? "px-0 py-[4px] pr-[16px] text-[12px] leading-[14px]" : e.size === "sm" ? "px-0 py-[13px] pr-[45px] text-[13px] leading-[16px]" : "px-0 py-[13px] pr-[45px] text-[16px] leading-[20px]",
                  e.disabled ? "text-input-text-disable placeholder:text-input-text-disable cursor-not-allowed" : "text-input-text-static placeholder:text-input-text-placeholder placeholder:font-normal placeholder:tracking-[-0.35px]"
                ]),
                style: V(
                  e.disabled ? "color: var(--font-color-default-muted-dark) !important; opacity: 1;" : ""
                ),
                placeholder: s.placeholder,
                onChange: z,
                onKeydown: O,
                onBlur: w
              }, null, 8, ["class", "style", "placeholder"]),
              f(i(U), {
                class: n([
                  "absolute right-0 top-0 flex h-full items-center",
                  e.variant === "compact" ? "pr-[8px]" : "pr-[15px]",
                  e.disabled ? "bg-input-bg-disabled cursor-not-allowed" : "cursor-pointer"
                ]),
                style: V(
                  e.disabled ? "color: var(--font-color-default-muted-dark) !important; opacity: 1;" : ""
                )
              }, {
                default: b(() => [
                  f($, {
                    name: "arrow-down",
                    size: e.variant === "compact" || s.size === "sm" ? "sm" : "md",
                    color: s.disabled ? "disabled" : "default",
                    class: n(`transition-transform duration-200 ${u ? "rotate-180" : ""}`)
                  }, null, 8, ["size", "color", "class"])
                ]),
                _: 2
              }, 1032, ["class", "style"])
            ], 2),
            g.value.length > 0 ? (c(), k(i(j), {
              key: 0,
              ref_key: "optionsRef",
              ref: v,
              class: n([
                "border-input-border-static absolute z-[1350] mt-0 max-h-60 w-full overflow-auto rounded-md border bg-[var(--input-color-surface)] shadow-lg",
                e.variant === "compact" ? "py-0.5" : "py-1"
              ])
            }, {
              default: b(() => [
                (c(!0), C(K, null, Q(g.value, (r) => (c(), k(i(A), {
                  key: r.value,
                  value: r,
                  disabled: r.disabled
                }, {
                  default: b(({ active: F, selected: I }) => [
                    x("li", {
                      class: n([
                        "relative cursor-default select-none tracking-[-0.35px]",
                        e.variant === "compact" ? "py-1 pl-2 pr-3 text-[12px] leading-[14px]" : "py-2 pl-3 pr-9 text-[13px] leading-[16px]",
                        r.disabled ? "text-input-text-disable cursor-not-allowed opacity-50" : F ? "text-input-text-static bg-[var(--background-bg-surface-muted)]" : "text-input-text-static",
                        I && !r.disabled ? "font-medium" : ""
                      ])
                    }, [
                      x("span", J, R(r.label), 1)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["value", "disabled"]))), 128))
              ]),
              _: 1
            }, 8, ["class"])) : T("", !0)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]));
  }
});
export {
  Y as default
};
